
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule, DeviceType } from '@/store/modules/app'
import { AUDITAPI } from '@/api/statistic'
import {
  getRole,
  getuserCurrentApp,
  getuserCurrentAppName,
  getIsSingleEntry, setTempAppid, getTempAppid
} from '@/utils/cookies'
import { UserModule } from '@/store/modules/user'
import {
  isItTicketType,
  isLiveType,
  isNetworkTicketType,
  isAdministrationTicketType,
  isFuWuBaoZhangTicketType,
  isCaiGouGuanLiTicketType, isShengChanGuanLiTicketType, isShangPinYunYingTicketType, isGongYingGuanLiTicketType
} from '@/utils/commonFunc'
import { LIVEAUDIAPI } from '@/api/live'
import { NETWORKAUDIAPI } from '@/api/network'
import { ADMINISAUDIAPI } from '@/api/administration'
import { FWBZISAUDIAPI } from '@/api/fwbz'
import { CGGLISAUDIAPI } from '@/api/cggl'
import { SCGLISAUDIAPI } from '@/api/scgl'
import { SPYYISAUDIAPI } from '@/api/spyy'
import { GYGLISAUDIAPI } from '@/api/gygl'

@Component({
  components: {}
})
export default class Home extends Vue {
  public $echarts: any;
  private bgColors = [
    '#66ce6d',
    '#3abaff',
    '#36bf93',
    '#559cf3',
    '#33c9e2',
    '#fda328',
    '#f16666'
  ];

  private createEntryCard = [
    {
      // 发起人快捷入口
      tit: '新建工单',
      icon: 'fudao',
      url: '/newOrder/tutor'
    }
    //   {
    //   tit: 'LP(学规)工单',
    //   icon: 'lp',
    //   url: '/newOrder/lp'
    // }
  ];

  private manageEntryCard = [
    {
      // 保障/管理员快捷入口
      tit: '工单管理',
      icon: 'liebiao',
      bg: '#fda328',
      url: '/managedOrder/all'
    },
    {
      tit: '个人看板',
      icon: 'kanban',
      bg: '#33c9e2',
      url: '/statistic/own'
    },
    {
      isManager: true, // 是否为管理员
      onlyMobile: true, // 仅移动端操作
      tit: '基础配置',
      icon: 'peizhi',
      bg: '#f16666',
      url: 'config/all'
    }
  ];

  private adminEntryCard = [
    {
      // 超级管理员快捷入口
      tit: '所有工单',
      icon: 'quanbu',
      bg: '#559cf3',
      url: '/ordersCenter/all'
    },
    {
      tit: '工单统计',
      icon: 'tongji',
      bg: '#36bf93',
      url: '/ordersCenter/statistic'
    }
  ];

  private AreaRoute = [
    // 地区看板路由【管理员】IT，网络拥有
    {
      tit: '地区看板',
      icon: 'ditu',
      bg: '#66ce6d',
      url: '/statistic/area'
    }
  ];

  private ManualWorkRoute = [
    // 手动录入工单路由 直播保障，网络拥有
    {
      tit: '手动录入',
      icon: 'group6',
      bg: '#559cf3',
      url: '/manualWork'
    }
  ];

  private numCard = [];
  private total = 0;
  private waiterCard = [];
  private waiterTotal = 0;
  private appEnv = '';

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get userCurrentAppName() {
    return getuserCurrentAppName()
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  // 角色
  get ROLE() {
    return Number(UserModule.roles || getRole() || 1)
  }

  // navbar日期值
  get navbarDate() {
    return AppModule.navbarDate
  }

  // navbar日期筛选框改变时，刷新
  @Watch('navbarDate')
  private onNavbarDateChange() {
    this.getAuditData()
  }

  mounted() {
    this.appEnv = process.env.VUE_APP_ENV as string
    this.getAuditData()
    this.appendRouteByRole()
    // 展示navbar时间筛选框；
    AppModule.SetShowNavbarDate(true)
    let appid = this.userCurrentApp
    if (appid) {
      setTempAppid(appid)
    } else {
      appid = getTempAppid()
    }
    // const appid = getuserCurrentApp()
    const isSingleEntry = getIsSingleEntry()
    const query = this.$route.query
    if (appid && isSingleEntry && query.id) {
      this.$router
        .replace({
          path: '/createIndex',
          query: { t: String(new Date().getTime()) }
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {
        })
    }
    // else {
    //   console.log(22222)
    //   this.$router
    //     .replace({
    //       path: '/jumper',
    //       query: { t: String(new Date().getTime()) }
    //     })
    //     // eslint-disable-next-line @typescript-eslint/no-empty-function
    //     .catch(() => {
    //     })
    // }
  }

  beforeDestroy() {
    // 隐藏navbar时间筛选框；
    AppModule.SetShowNavbarDate(false)
  }

  private appendRouteByRole() {
    if ((isItTicketType() || isNetworkTicketType()) && this.ROLE > 2) {
      this.manageEntryCard.splice(2, 0, ...this.AreaRoute)
    }

    if (
      (isLiveType() || isNetworkTicketType()) &&
      !this.isMobile &&
      this.ROLE === 4
    ) {
      this.createEntryCard.push(...this.ManualWorkRoute)
    }
  }

  private handleRouter(item: any) {
    if (item.onlyMobile && this.isMobile) {
      this.$message({
        message: '请使用PC端访问此功能',
        type: 'error',
        showClose: true
      })
      return
    }
    this.$router.push({ path: item.url })
  }

  // 获取各个状态值
  private getAuditData() {
    if (this.ROLE > 1) {
      // 保障数据
      this.getAcceptData()
    } else {
      // 普通用户数据
      this.getCreateData()
    }
  }

  private async getCreateData() {
    let ApiModule: any = ''
    if (isLiveType()) {
      ApiModule = LIVEAUDIAPI
    } else if (isNetworkTicketType()) {
      ApiModule = NETWORKAUDIAPI
    } else if (isAdministrationTicketType()) {
      ApiModule = ADMINISAUDIAPI
    } else if (isFuWuBaoZhangTicketType()) {
      ApiModule = FWBZISAUDIAPI
    } else if (isCaiGouGuanLiTicketType()) {
      ApiModule = CGGLISAUDIAPI
    } else if (isShengChanGuanLiTicketType()) {
      ApiModule = SCGLISAUDIAPI
    } else if (isShangPinYunYingTicketType()) {
      ApiModule = SPYYISAUDIAPI
    } else if (isGongYingGuanLiTicketType()) {
      ApiModule = GYGLISAUDIAPI
    } else {
      ApiModule = AUDITAPI
    }
    let appid = this.userCurrentApp
    if (appid) {
      setTempAppid(appid)
    } else {
      appid = getTempAppid()
    }
    await ApiModule.getMyAudit({
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : '',
      app_id: appid
    }).then((res: any) => {
      if (res.stat === 1) {
        this.numCard = res.data.total
        this.total = res.data.count
      }
    })
  }

  private async getAcceptData() {
    let ApiModule: any = ''
    if (isLiveType()) {
      ApiModule = LIVEAUDIAPI
    } else if (isNetworkTicketType()) {
      ApiModule = NETWORKAUDIAPI
    } else if (isAdministrationTicketType()) {
      ApiModule = ADMINISAUDIAPI
    } else if (isFuWuBaoZhangTicketType()) {
      ApiModule = FWBZISAUDIAPI
    } else if (isCaiGouGuanLiTicketType()) {
      ApiModule = CGGLISAUDIAPI
    } else if (isShengChanGuanLiTicketType()) {
      ApiModule = SCGLISAUDIAPI
    } else if (isShangPinYunYingTicketType()) {
      ApiModule = SPYYISAUDIAPI
    } else if (isGongYingGuanLiTicketType()) {
      ApiModule = GYGLISAUDIAPI
    } else {
      ApiModule = AUDITAPI
    }
    await ApiModule.getDashboardWaiterData({
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : '',
      app_id: this.userCurrentApp,
      issue_type_1: '0',
      issue_type_2: '0'
    }).then((res: any) => {
      if (res.stat === 1) {
        this.numCard = res.data.building.status_result
        this.total = res.data.building.total
        this.waiterCard = res.data.my.status_result
        this.waiterTotal = res.data.my.total
      }
    })
  }

  // 跳转至工单列表页
  private handleToLists(status: any) {
    if (this.ROLE > 1) {
      // 保障
      this.$router.push({
        path: '/managedOrder/all',
        query: { status: status }
      })
    } else {
      // 普通用户
      this.$router.push({
        path: '/createdOrders/all',
        query: { status: status }
      })
    }
  }
}
